import React, { Component } from 'react'
import ArticleDialog from './ArticleDialog'
import ArticleWithVideo from './ArticleWithVideo'
import ArticleWithoutVideo from './ArticleWithoutVideo'

class Article extends Component {

    constructor(props) {
        super(props);

        this.state = {
            articleDialogVisible: false
        }
    }

    readMoreClickHandler = () => {
        this.setState({
            articleDialogVisible: true
        })
    }

    onCloseArticleDialog = () => {
        this.setState({
            articleDialogVisible: false
        })
    }

    createArticleDisplay= (title, description, haveAdditionalArticleDialog, videoUrl) => {
        if (videoUrl) {
            return (
                <ArticleWithVideo
                    title={title}
                    description={description}
                    readMoreClickHandler={this.readMoreClickHandler}
                    haveAdditionalArticleDialog={haveAdditionalArticleDialog}
                    videoUrl={videoUrl}
                />
            );
        }
        return (
            <ArticleWithoutVideo
                title={title}
                description={description}
                readMoreClickHandler={this.readMoreClickHandler}
                haveAdditionalArticleDialog={haveAdditionalArticleDialog}
            />
        );
    }

    render() {
        const { title, description } = this.props;
        const videoUrl = this.props.video_url ? "https://broadcast.amazon.com/embed/" + this.props.video_url : null;
        const haveAdditionalArticleDialog = this.props.body && this.props.body.length > 0 ? true : false; 
        return (
            <>
                {this.createArticleDisplay(title, description, haveAdditionalArticleDialog, videoUrl)}
                {haveAdditionalArticleDialog &&
                    <ArticleDialog
                        visible={this.state.articleDialogVisible}
                        onCloseDialog={this.onCloseArticleDialog}
                        title={this.props.title}
                        body={this.props.body}
                    />
                }
            </>
        );
    }
}


export default Article
